import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

const Content = styled.div``;

const Header = styled.div`
    padding: 8px 12px;
    display: flex;
    align-items: center;
    border-radius: 2px;

    cursor: pointer;
    &:hover {
        background: #dfdfdf;
    }
`;

const ChildArea = styled.div`
    height: 0;
    transition: max-height 1s ease-out;
    overflow: hidden;

    &.active {
        height: auto;
        transition: max-height 1s ease-in;
    }
`;

const Child = styled.div`
    padding: 0;
`;

const Circle = styled.div<{ identifier: Omit<IdentifierProps, 'value'> }>`
    border-radius: 50%;
    background: ${(props) => props.identifier.background || '#47516f'};
    height: 26px;
    width: 26px;
    color: ${(props) => props.identifier.color || '#fff'};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    margin: 0 12px 0 0;
    font-weight: 600;
`;

interface IdentifierProps {
    background?: string;
    color?: string;
    value: string | number;
}
interface CollapseProps {
    onClick: () => void;
    opened: boolean;
    header: FC<any> | Element | any;
    identifier?: IdentifierProps;
}

const Collapse: FC<CollapseProps & React.HTMLAttributes<HTMLDivElement>> = ({
    opened,
    children,
    header,
    onClick,
    identifier,
    ...rest
}) => {
    const [isOpened, setIsOpened] = useState<boolean>(opened);

    useEffect(() => {
        setIsOpened(opened);
    }, [opened]);

    return (
        <Content {...rest}>
            <Header className='headerAera' onClick={onClick}>
                {identifier?.value !== undefined && (
                    <Circle identifier={identifier}>{identifier.value}</Circle>
                )}
                {header}
            </Header>
            <ChildArea className={`childArea ${isOpened ? 'active' : ''}`}>
                <Child>{children}</Child>
            </ChildArea>
        </Content>
    );
};

export { Collapse };
